<button
  type="button"
  class="sel-trigger"
  role="combobox"
  aria-haspopup="listbox"
  [attr.aria-label]="ariaLabel() || null"
  [attr.aria-expanded]="open()"
  [attr.aria-controls]="open() ? listId : null"
  [attr.aria-activedescendant]="
    open() && highlighted() >= 0 ? optId(highlighted()) : null
  "
  (click)="toggle()"
  (keydown)="onKeydown($event)"
>
  <span class="sel-val" [class.placeholder]="!value()">{{
    displayValue()
  }}</span>
  <span class="sel-arrow" aria-hidden="true">▾</span>
</button>

@if (open()) {
  <div
    class="sel-dropdown"
    role="listbox"
    [id]="listId"
    [style.top.px]="dropdownTop() ?? null"
    [style.bottom.px]="dropdownBottom() ?? null"
    [style.right.px]="dropdownRight()"
    [style.min-width.px]="dropdownMinWidth()"
  >
    @for (opt of options(); track opt; let i = $index) {
      <button
        type="button"
        class="sel-item"
        role="option"
        [id]="optId(i)"
        [attr.aria-selected]="value() === opt"
        [class.sel]="value() === opt"
        [class.hl]="highlighted() === i"
        (click)="select(opt)"
        (mouseenter)="highlighted.set(i)"
      >
        {{ opt || placeholder() }}
      </button>
    }
  </div>
}
